import { render, staticRenderFns } from "./ModalEntregarRemito.vue?vue&type=template&id=6955f200"
import script from "./ModalEntregarRemito.vue?vue&type=script&lang=js"
export * from "./ModalEntregarRemito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports